import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { NavigationService } from '../navigation/navigation.service';
import { LogService } from '../logging/log.service';
import { RoleSecurityService } from './role-security.service';

@Injectable()
export class PageRestrictionGuard implements CanActivate {
    LOG_SOURCE = 'PageRestrictionGuard';

    constructor(
        private readonly roleSecurityService: RoleSecurityService,
        private readonly navigationService: NavigationService,
        private readonly logService: LogService
    ) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        if (!route?.routeConfig?.path) {
            this.logService.warn(this.LOG_SOURCE, 'Path in routeConfig not configured for route', {});
            return of(true);
        }
        const page = this.navigationService.getPageByPath(route.routeConfig.path);
        if (!page) {
            this.logService.warn(this.LOG_SOURCE, `Page for path '${route.routeConfig.path}' is undefined`, {});
            return of(true);
        }
        if (!page.restrictionKey) {
            this.logService.warn(
                this.LOG_SOURCE,
                `Restriction key for path '${route.routeConfig.path}' is undefined`,
                {}
            );
            return of(true);
        }
        return of(this.roleSecurityService.userCanView(page.restrictionKey));
    }
}
